import PropTypes from 'prop-types'

export const propTypes = {
  className: PropTypes.string
}

export const defaultProps = {}
